import { useAppStore } from '../app/state/useAppStore';

export function EntitlementSwitch() {
  const edition = useAppStore((state) => state.entitlement.edition);
  const setMockEdition = useAppStore((state) => state.setMockEdition);

  if (!import.meta.env.DEV) {
    return <span className="edition-badge">{edition}</span>;
  }

  return (
    <label className="entitlement-switch">
      <span>Mock entitlement</span>
      <select
        aria-label="Mock entitlement"
        onChange={(event) => setMockEdition(event.target.value === 'pro' ? 'pro' : 'free')}
        value={edition}
      >
        <option value="free">Free</option>
        <option value="pro">Pro</option>
      </select>
    </label>
  );
}
